function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M137.527 54.1285L156.975 18.3363V16.4525H123.261V25.9388H141.834L122.185 62.0674V63.5475H157.782V54.1285H137.527Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M175.211 54.1285V44.4404H191.563V35.2232H175.211V25.8715H193.313V16.4525H165.05V63.5475H194.053V54.1285H175.211Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M228.547 63.5475H239.919L229.489 45.786C234.738 43.2294 238.102 38.2508 238.102 32.0611C238.102 22.9785 231.037 16.4525 221.616 16.4525H202.639V63.5475H212.8V47.5352H219.328L228.547 63.5475ZM212.8 25.8715H220.943C225.25 25.8715 227.739 28.4954 227.739 31.9939C227.739 35.5596 225.25 38.1162 220.943 38.1162H212.8V25.8715Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M269.075 64.6239C283.408 64.6239 294.108 54.0612 294.108 40C294.108 26.0061 283.408 15.4434 269.075 15.4434C254.675 15.4434 243.908 26.0734 243.908 40C243.908 53.9939 254.675 64.6239 269.075 64.6239ZM269.075 55.0031C260.664 55.0031 254.271 48.4771 254.271 40C254.271 31.5229 260.664 25.0642 269.075 25.0642C277.487 25.0642 283.745 31.4556 283.745 40C283.745 48.5444 277.487 55.0031 269.075 55.0031Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M312.724 54.1285L332.171 18.3363V16.4525H298.458V25.9388H317.03L297.381 62.0674V63.5475H332.979V54.1285H312.724Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M350.408 54.1285V44.4404H366.76V35.2232H350.408V25.8715H368.51V16.4525H340.247V63.5475H369.25V54.1285H350.408Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M403.743 63.5475H415.116L404.686 45.786C409.934 43.2294 413.299 38.2508 413.299 32.0611C413.299 22.9785 406.233 16.4525 396.812 16.4525H377.836V63.5475H387.997V47.5352H394.524L403.743 63.5475ZM387.997 25.8715H396.139C400.446 25.8715 402.936 28.4954 402.936 31.9939C402.936 35.5596 400.446 38.1162 396.139 38.1162H387.997V25.8715Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M444.272 64.6239C458.605 64.6239 469.305 54.0612 469.305 40C469.305 26.0061 458.605 15.4434 444.272 15.4434C429.871 15.4434 419.104 26.0734 419.104 40C419.104 53.9939 429.871 64.6239 444.272 64.6239ZM444.272 55.0031C435.86 55.0031 429.467 48.4771 429.467 40C429.467 31.5229 435.86 25.0642 444.272 25.0642C452.683 25.0642 458.941 31.4556 458.941 40C458.941 48.5444 452.683 55.0031 444.272 55.0031Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M72.1484 64.5142C77.4077 57.7429 80.5391 49.2366 80.5391 39.999C80.5391 30.7614 77.4078 22.2553 72.1487 15.484C72.8854 15.4177 73.6314 15.3838 74.3853 15.3838C87.98 15.3838 99.0006 26.4045 99.0006 39.9991C99.0006 53.5938 87.98 64.6145 74.3853 64.6145C73.6313 64.6145 72.8852 64.5806 72.1484 64.5142Z",
  fill: "url(#paint0_linear_1132_14562)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M72.1486 64.5152C77.4079 57.7439 80.5393 49.2375 80.5393 39.9998C80.5393 30.7624 77.408 22.2562 72.149 15.485C59.6023 16.6149 49.77 27.1593 49.77 40.0001C49.77 52.8408 59.6021 63.3851 72.1486 64.5152Z",
  fill: "url(#paint1_linear_1132_14562)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M72.1486 15.485C59.602 16.615 49.7698 27.1594 49.7698 40.0001C49.7698 52.8409 59.6019 63.3852 72.1484 64.5153C64.8305 73.9372 53.3928 80 40.5391 80C18.4477 80 0.539062 62.0914 0.539062 40C0.539062 17.9086 18.4477 0 40.5391 0C53.3929 0 64.8307 6.06293 72.1486 15.485Z",
  fill: "url(#paint2_linear_1132_14562)"
});

var _ref13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1132_14562",
  x1: 72.0296,
  y1: 15.3838,
  x2: 72.0296,
  y2: 64.6145,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00BBEE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0044EE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_1132_14562",
  x1: 53.8214,
  y1: 25.3334,
  x2: 72.129,
  y2: 64.5128,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4BD2FB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0044EE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_1132_14562",
  x1: 20.1867,
  y1: 5.7758,
  x2: 45.6039,
  y2: 80.6029,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FCB010"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#FC3010"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D31803"
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 470,
    height: 80,
    viewBox: "0 0 470 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.c853a4ec.svg";
export { ForwardRef as ReactComponent };